import { useState } from 'react';

import { useActiveWindowInterval } from '#/components/hooks';

/**
 * Current timestamp (ms) kept in state, refreshed on the given interval.
 * Ticks only while the window/tab is active and catches up when the user
 * returns to the window. Use instead of calling Date.now() during render
 * when displayed durations should keep updating while staying on the page.
 */
export function useNow(intervalMs = 10_000): number {
  const [now, setNow] = useState(() => Date.now());

  useActiveWindowInterval(() => {
    setNow(Date.now());
  }, intervalMs);

  return now;
}
